module.exports = __webpack_public_path__ + "static/assets/df5e3b7655a9bdb6893775985415d50f.svg";